import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { ENTRY_MODE, STORE_DineType } from "../../../../database/store-names";
import { CSP, ENCRYPT_STORAGE } from "../../../../config/config";
import { dto_CustomerAddress } from "../../../../classes/dto-customer";
import { dto_cart_checkout } from "../../../../classes/dto-cart-checkout";
import { Get_CustomerCSID } from "../../../../database/get-stored-data";
import { dto_common } from "../../../../classes/dto-common";
import { F_Fammily } from "../../../../util/config-fonts";
import { PT_SIGNIN } from "../../../../routes/stack/paths/pt-profile";
import { Colors } from "../../../../util/colors";
import Alert from "../../../../components/Alert";
import { ToastMessage } from "../../../../components/toast-notification/toast";

function ConfirmBtn({
  navigate,
  MinOrderValue,
  MaxOrderValue,
  SubTotal,
  Error,
  NavigateToPayMode,
  EmptyScheduleDnT,
}) {
  const SelectedDineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
  const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
  const isDtPosOrQr = CSP === "DT" && entryMode === "QR";
  return (
    <button
      style={{
        cursor: "pointer",
        width: "100%",
        minHeight: "52px",
        fontFamily: F_Fammily.Medium,
        backgroundColor: Colors.DarkGreyScale,
        color: "white",
        borderRadius: "8px",
        marginTop: 6,
        border: "none",
        fontSize: "15px",
        letterSpacing: "0.04em",
        padding: "0 18px",
      }}
      onClick={async () => {
        var CSID = await Get_CustomerCSID();
        if (
          !isDtPosOrQr &&
          entryMode === "QR" &&
          (CSID === 0 || CSID === undefined)
        ) {
          navigate(PT_SIGNIN);
          return;
        }

        for (let i = 0; i < dto_cart_checkout.Cart.length; i++) {
          if (CSP === "AV") {
            if (
              dto_cart_checkout.Cart[i].TID !== 5 &&
              dto_cart_checkout.Cart[i].PID !== 1224929 &&
              dto_cart_checkout.Cart[i].IsAvailable === false
            ) {
              // Alert.MessageBox({
              //   ConfirmButtonText: "OK",
              //   Icon: "warnig",
              //   Text:
              //     "<div style='flex:row;'>From your shopping list <p style='margin:0px;color:darkblue;font-weight:bold;display: contents;'>" +
              //     dto_cart_checkout.Cart[i].Desc +
              //     "</p> currently <p style='margin:0px;color:red;font-weight:bold;display: contents;'>not available</p> please change the  item for this order</div>",
              //   Tittle: "Info",
              // });
              ToastMessage(
                3,
                "<div style='flex:row;'>From your shopping list <p style='margin:0px;color:darkblue;font-weight:bold;display: contents;'>" +
                  dto_cart_checkout.Cart[i].Desc +
                  "</p> currently <p style='margin:0px;color:red;font-weight:bold;display: contents;'>not available</p> please change the  item for this order</div>",
              );

              return;
            }
          } else {
            if (
              dto_cart_checkout.Cart[i].TID !== 5 &&
              dto_cart_checkout.Cart[i].IsAvailable === false
            ) {
              // Alert.MessageBox({
              //   ConfirmButtonText: "OK",
              //   Icon: "warnig",
              //   Text:
              //     "<div style='flex:row;'>From your shopping list <p style='margin:0px;color:darkblue;font-weight:bold;display: contents;'>" +
              //     dto_cart_checkout.Cart[i].Desc +
              //     "</p> currently <p style='margin:0px;color:red;font-weight:bold;display: contents;'>not available</p> please change the existing item for this</div>",
              //   Tittle: "Info",
              // });

              ToastMessage(
                3,
                "<div style='flex:row;'>From your shopping list <p style='margin:0px;color:darkblue;font-weight:bold;display: contents;'>" +
                  dto_cart_checkout.Cart[i].Desc +
                  "</p> currently <p style='margin:0px;color:red;font-weight:bold;display: contents;'>not available</p> please change the existing item for this</div>",
              );

              return;
            }
          }
        }

        if (SelectedDineType === 0) {
          // Alert.MessageBox({
          //   Tittle: "Info",
          //   Icon: "error",
          //   ConfirmButtonText: "OK",
          //   Text: "Please select Delivery or Self pickup",
          // });
          ToastMessage(1, "Please select Delivery or Self pickup");

          return;
        }

        if (parseInt(SelectedDineType) === 4 && CSP === "AV") {
          let hasDeliveryCharge = false;
          let cartItems = dto_cart_checkout.Cart;

          for (let i = 0; i < cartItems.length; i++) {
            if (cartItems[i].TID === 5) {
              hasDeliveryCharge = true;
              break;
            }
          }

          if (!hasDeliveryCharge) {
            // Alert.MessageBox({
            //   Tittle: "Info",
            //   Icon: "error",
            //   ConfirmButtonText: "OK",
            //   Text: "Something went wrong.",
            // });

            ToastMessage(3, "Something went wrong.");

            return;
          }
        }

        if (parseFloat(MinOrderValue) >= parseFloat(SubTotal)) {
          // Alert.MessageBox({
          //   Tittle: "Info",
          //   Icon: "error",
          //   ConfirmButtonText: "OK",
          //   Text:
          //     "Sub-Total bill value must be above" +
          //     " " +
          //     dto_StartupPageLoadInfo.Currency +
          //     " " +
          //     MinOrderValue,
          // });

          ToastMessage(
            2,
            "Sub-Total bill value must be above" +
              " " +
              dto_StartupPageLoadInfo.Currency +
              " " +
              MinOrderValue,
          );

          return;
        } else if (parseFloat(MaxOrderValue) !== 0.0) {
          if (parseFloat(MaxOrderValue) <= parseFloat(SubTotal)) {
            // Alert.MessageBox({
            //   Tittle: "Info",
            //   Icon: "info",
            //   ConfirmButtonText: "OK",
            //   Text:
            //     "Sub-Total bill value must be below" +
            //     " " +
            //     dto_StartupPageLoadInfo.Currency +
            //     " " +
            //     MaxOrderValue,
            // });

            ToastMessage(
              1,
              "Sub-Total bill value must be below" +
                " " +
                dto_StartupPageLoadInfo.Currency +
                " " +
                MaxOrderValue,
            );
            return;
          }
        } else if (
          CSP === "MK" &&
          (dto_common.SCHEDULEDDATE === "" || dto_common.SCHEDULEDTIME === "")
        ) {
          EmptyScheduleDnT();
          console.log(dto_common.SCHEDULEDDATE);
          console.log(dto_common.SCHEDULEDTIME);
          return;
        } else {
          if (Error !== "" && Error !== undefined) {
            // Alert.MessageBox({
            //   Tittle: "Info",
            //   Icon: "info",
            //   ConfirmButtonText: "OK",
            //   Text: Error,
            // });

            ToastMessage(3, Error);
            return;
          }
          if (parseInt(SelectedDineType) === 4) {
            const shouldSkipAddressCheck =
              isDtPosOrQr && (CSID === 0 || CSID === undefined);
            if (!shouldSkipAddressCheck) {
              if (
                dto_CustomerAddress.AddressGuid === undefined ||
                dto_CustomerAddress.AddressGuid === ""
              ) {
                // Alert.MessageBox({
                //   Tittle: "Info",
                //   Icon: "info",
                //   ConfirmButtonText: "OK",
                //   Text: "Select your address",
                // });
                ToastMessage(1, "Select your address");

                return;
              }
            }
            let Message = "";
            Message =
              "<div class='ConfirmOrderType'>" +
              "<p>" +
              (SelectedDineType === 4
                ? "<i class='fa fa-motorcycle' aria-hidden='true' style=margin:5px;'font-size: 18px;></i> Delivery Order "
                : "<i class='bi bi-bag-fill' aria-hidden='true' style=margin:5px;'font-size: 18px;></i> Pick Up Order") +
              "</p>" +
              "</div>" +
              '<div class="confirmAdd">' +
              "<div>" +
              '<i class="bi bi-geo-alt-fill" aria-hidden="true" style="margin:3px;font-size: 18px;"></i>' +
              "</div>" +
              "<div>" +
              '<p style="margin:3px;font-size:15px;text-align:left;">' +
              dto_CustomerAddress.DefaultAdd1 +
              " " +
              dto_CustomerAddress.DefaultAdd2 +
              " " +
              dto_CustomerAddress.DefaultAdd3 +
              "</p>" +
              "</div>";

            if (dto_common.SCHEDULEDDATE !== "") {
              Message =
                "<div class='ConfirmOrderType'>" +
                "<p>" +
                (SelectedDineType === 4
                  ? "<i class='fa fa-motorcycle' aria-hidden='true' style=margin:3px;'font-size: 18px;></i> Delivery Order "
                  : "<i class='bi bi-bag-fill' aria-hidden='true' style=margin:3px;'font-size: 18px;></i> Pick Up Order") +
                "</p>" +
                "</div>" +
                '<div class="confirmAdd">' +
                "<div class='confirmAddIco'>" +
                '<i class="bi bi-geo-alt-fill" aria-hidden="true" style="margin:3px;font-size: 18px;"></i>' +
                "<i class='bi bi-calendar-check' aria-hidden='true' style=margin:3px;'font-size: 18px;'></i>" +
                "</div>" +
                "<div>" +
                '<p style="margin:3px;font-size:15px;text-align:left;margin-bottom: 15px;"> ' +
                dto_CustomerAddress.DefaultAdd1 +
                " " +
                dto_CustomerAddress.DefaultAdd2 +
                " " +
                dto_CustomerAddress.DefaultAdd3 +
                " " +
                "</p><div> <p style='font-size: 15px;margin:0px'>" +
                dto_common.SCHEDULEDTIME +
                "</p><p style='font-size: 15px;margin:0px'>" +
                dto_common.SCHEDULEDDATE +
                "</p></div>" +
                "</div>";
            }

            if (CSP === "AV") {
              Alert.ConfirmationMessageBox({
                Icon: "info",
                Tittle: "Confirmation",
                Text: Message,
                ConfirmButtonText: "OK",
                CancelButtonMessage: "Cancel",
                ConfirmButtonFunction: async () => {
                  NavigateToPayMode(navigate);
                },
                DismissButtonFunction: async () => {},
              });
            } else {
              NavigateToPayMode(navigate);
            }
          } else {
            if (CSP === "AV") {
              Alert.ConfirmationMessageBox({
                Icon: "info",
                Tittle: "Confirmation",
                Text:
                  SelectedDineType === 4
                    ? "Delivery"
                    : "</br>This is a <b>Pick Up</b> order. <br/> <br/> Are you sure, you want to place the order?",
                ConfirmButtonText: "OK",
                CancelButtonMessage: "Cancel",
                ConfirmButtonFunction: async () => {
                  NavigateToPayMode(navigate);
                },
                DismissButtonFunction: async () => {},
              });
            } else {
              NavigateToPayMode(navigate);
            }
          }
        }
      }}
    >
      {isDtPosOrQr ? "PROCEED TO CHECK OUT" : "PROCEED TO CHECK OUT"}
    </button>
  );
}

export default ConfirmBtn;
